<template>
  <div class="inlineFlex taskSelect">
    <div class="selectBox">
      <v-select
        label="大分類"
        item-text="taskTypeName"
        item-value="taskTypeId"
        v-model="majorTaskType"
        :items="majorTaskList"
        :disabled="disabled"
        @change="setMajorTaskType"
        class="UXselect"
        color="#6D8DFF"
        hide-details
        outline
        solo
      ></v-select>
    </div>
    <div class="selectBox">
      <v-select
        label="中分類"
        item-text="taskTypeName"
        item-value="taskTypeId"
        v-model="middleTaskType"
        :items="middleTaskList"
        :disabled="disabled"
        @change="setMiddleTaskType"
        class="UXselect"
        color="#6D8DFF"
        hide-details
        outline
        solo
        no-data-text="データがありません。"
      ></v-select>
    </div>
    <div class="selectBox">
      <v-select
        label="小分類"
        item-text="taskTypeName"
        item-value="taskTypeId"
        v-model="minorTaskType"
        :items="minorTaskList"
        :disabled="disabled"
        @change="setMinorTaskType"
        class="UXselect"
        color="#6D8DFF"
        hide-details
        outline
        solo
        no-data-text="データがありません。"
      ></v-select>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import eventType from '@/components/menus/ticket/enums/eventType'
import eventBus from '@/event_bus'
import TicketListUtil from '../../../util/ticket_list_util'
import PageType from '../../../enums/pageType'
import OptionType from '../../../enums/ticketListOptionType'

export default {
  name: 'ticket_counsel_type',
  props: {
    updateMajorTaskType: Function,
    updateMiddleTaskType: Function,
    updateMinorTaskType: Function,
    disabled: Boolean,
    pageType: String
  },
  data: () => ({
    majorTaskType: null,
    middleTaskType: null,
    minorTaskType: null,
    majorTaskList: [],
    middleTaskList: [],
    minorTaskList: []
  }),
  methods: {
    setMajorTaskType () {
      const data = this.majorTaskType
      this.middleTaskList = []
      this.minorTaskList = []
      this.updateMajorTaskType(data)
      this.middleTaskType = null
      this.minorTaskType = null
      this.callMiddleTaskType()
    },
    setMiddleTaskType () {
      const data = this.middleTaskType
      this.minorTaskList = []
      this.updateMiddleTaskType(data)
      this.minorTaskType = null
      this.callMinorTaskType()
    },
    setMinorTaskType () {
      const data = this.minorTaskType
      this.updateMinorTaskType(data)
    },
    callMajorTaskType () {
      if (this.currentTicketBrandId) {
        this.axios.get('/gateway/ticket/brand/taskType/major', {
          params: {
            ticketBrandId: this.currentTicketBrandId
          }
        }).then((res) => {
          this.majorTaskList = res.data.data
        })
      }
    },
    callMiddleTaskType () {
      if (this.currentTicketBrandId && this.majorTaskType) {
        this.axios.get('/gateway/ticket/brand/taskType/middle', {
          params: {
            ticketBrandId: this.currentTicketBrandId,
            parentTaskTypeId: this.majorTaskType
          }
        }).then((res) => {
          this.middleTaskList = res.data.data
        })
      }
    },
    callMinorTaskType () {
      if (this.currentTicketBrandId && this.middleTaskType) {
        this.axios.get('/gateway/ticket/brand/taskType/minor', {
          params: {
            ticketBrandId: this.currentTicketBrandId,
            parentTaskTypeId: this.middleTaskType
          }
        }).then((res) => {
          this.minorTaskList = res.data.data
        })
      }
    },
    resetAll () {
      this.majorTaskList = []
      this.middleTaskList = []
      this.minorTaskList = []
      this.majorTaskType = null
      this.middleTaskType = null
      this.minorTaskType = null
    },
    unselected () {
      this.middleTaskList = []
      this.minorTaskList = []
      this.majorTaskType = null
      this.middleTaskType = null
      this.minorTaskType = null
    }
  },
  mounted () {
    if (this.pageType !== PageType.DASHBOARD_PAGE) {
      this.majorTaskType = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.MAJOR_TASK, localStorage.getItem('TICKET_LIST_OPTION'))
      this.middleTaskType = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.MIDDLE_TASK, localStorage.getItem('TICKET_LIST_OPTION'))
      this.minorTaskType = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.MINOR_TASK, localStorage.getItem('TICKET_LIST_OPTION'))
    } else {
      this.resetAll()
    }
    eventBus.$on(eventType.UNSELECT_TASK_TYPE, () => {
      this.unselected()
    })
    this.$nextTick(() => {
      if (this.currentTicketBrandId) {
        this.callMajorTaskType()
        this.callMiddleTaskType()
        this.callMinorTaskType()
      }
    })
  },
  destroyed () {
    eventBus.$off(eventType.FETCH_TICKET_BRAND)
    eventBus.$off(eventType.UNSELECT_TASK_TYPE)
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'ticketAgentId'
    ])
  },
  watch: {
    currentTicketBrandId () {
      this.callMajorTaskType()
      this.callMiddleTaskType()
      this.callMinorTaskType()
    }
  }
}
</script>

<style scoped lang="scss">
.taskSelect {
  width: 100%;
  display: table;
  table-layout: fixed;
  .selectBox {
    position: relative;
    display: table-cell;
    padding-right: 5px;
    .v-list__tile {
      height: auto;
      .v-list__tile__title {
        overflow: visible;
        white-space: normal;
        word-break: break-all;
        height: auto;
        line-height: 1.5;
        padding: 10px 0;
      }
    }
    .v-select__selections {
      width: 87%;
    }
    &:last-child {
      padding-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_counsel_type.vue